export default __webpack_public_path__ + "locales/uk-UA/PeopleTranslations.json?hash=a9ef1737d3658301728fc614be203036";